'use client';

import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import useIsDarkMode from '@/app/lib/hooks/useIsDarkMode';

const Orb = styled(Box)(({ theme }) => ({
	position: 'absolute',
	width: '50vw',
	height: '50vw',
	minWidth: '250px',
	minHeight: '250px',
	maxWidth: '600px',
	maxHeight: '600px',
	borderRadius: '50%',
	background: `${theme.palette.vMaroon.main}30`,
	zIndex: 1,
	pointerEvents: 'none',
	[theme.breakpoints.up('md')]: {
		width: '30vw',
		height: '30vw'
	}
}));

const PageContainer = ({ children }) => {
	const isDarkMode = useIsDarkMode();
	return (
		<Box
			component="main"
			sx={{
				minHeight: '100vh',
				overflow: 'hidden',
				position: 'relative',
				py: 16,
				backgroundColor: theme => (isDarkMode ? theme.palette.vNavyBlue.main : theme.palette.vDirtyWhite.main),
				'&:before': {
					content: '""',
					position: 'absolute',
					top: { xs: '-5%', md: '-10%' },
					left: '-3%',
					width: { xs: '550px', md: '920px' },
					height: { xs: '550px', md: '920px' },
					backgroundImage: 'url(/globe.webp)',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					transform: 'rotate(25deg)',
					mixBlendMode: 'exclusion',
					opacity: 0.05,
					pointerEvents: 'none'
				},
				'&:after': {
					content: '""',
					position: 'absolute',
					bottom: '-45px',
					right: { xs: '40%', md: '15%' },
					width: '100%',
					height: '100%',
					maxWidth: { xs: '310px', md: '440px' },
					maxHeight: { xs: '150px', md: '170px' },
					backgroundImage: 'url(/plane.webp)',
					backgroundSize: 'contain',
					backgroundPosition: '0px -10px',
					backgroundRepeat: 'no-repeat',
					transform: 'rotateZ(-15deg)',
					pointerEvents: 'none',
					zIndex: 1
				}
			}}>
			{isDarkMode && <Orb sx={{ top: 0, right: 0, filter: 'blur(300px)', transform: 'translateX(40%)' }} />}
			{isDarkMode && <Orb sx={{ bottom: 0, left: 0, filter: 'blur(300px)', transform: 'translateX(-40%)' }} />}
			{children}
		</Box>
	);
};

export default PageContainer;
